var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.row.NOMBRE))]),_c('td',[_vm._v(_vm._s(_vm.row.phone))]),_c('td',[_vm._v(_vm._s(_vm.row.activity))]),_c('td',[_vm._v(_vm._s(_vm.row.OCUPADO))])])}
var staticRenderFns = []

export { render, staticRenderFns }